module.exports = __webpack_public_path__ + "static/media/group_everyreel.6461db81.svg";